import { SideChatMessage } from '@assets/model/SideChatStore';
import RecommendL3Message from './RecommendL3/RecommendL3Message';
import TextMessage from './TextMessage/TextMessage';
import SystemMessage from './TextMessage/TextMessage';
import AttachFactsMessage from './AttachFacts/AttachFacts';
import { NarrativeStore } from '@assets/model/NarrativeStore';

export type ReplyMessageType = 'text' | 'recommend_L3' | 'attach_facts';

export class ReplyMessageFactory {
    static createMessageByType(
        type: ReplyMessageType,
        data: SideChatMessage,
        key: string,
        narStore: NarrativeStore
    ) {
        switch (type) {
            case 'text':
                return <TextMessage key={key} message={data} />;
            case 'recommend_L3':
                return (
                    <RecommendL3Message
                        key={key}
                        message={data}
                        narStore={narStore}
                    />
                );
            case 'attach_facts':
                return (
                    <AttachFactsMessage
                        key={key}
                        message={data}
                        narStore={narStore}
                    />
                );
            default:
                console.log(`Unknown message type: ${type}`);
                return <div>Unknown message type {type}</div>;
        }
    }
}
